import { Injectable } from '@angular/core';
import { ApiClientService } from 'projects/dnest-core-angular/src/public-api';
import { UserWorkCenter } from 'src/app/models/user-work-center';

@Injectable({
  providedIn: 'root'
})
export class KamWorkcenterApiClientService extends ApiClientService<UserWorkCenter> {
  endpoint = 'workcenter';
}

